import { render } from "./BaseCard.vue?vue&type=template&id=1a8b82fc&scoped=true&ts=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=1a8b82fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8b82fc"]])

export default __exports__